export default "__VITE_ASSET__Crp29quX__"